import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Privacypolicy = () => {
  return (
    <div className="container mt-5">
      {/* Header Section */}
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="mb-4">Privacy Policy</h1>
          <p><strong>Last Updated as of 28 February 2024</strong></p>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="row">
        <div className="col-12">
          <h2>Introduction</h2>
          <p>
            These Services (as defined below) are run by Fashnear Technologies Private Limited and its affiliates (Company, We, Us, and Our) under the brand name “Valmo”. We respect your privacy and are committed to protect it by complying with this policy (Privacy Policy). The Privacy Policy applies to the use or access of Valmo's website “valmo.in”, mobile application, any offline business run under the brand name of Valmo and any of the platforms/tools developed by us from time to time (together referred to as Services). The Privacy Policy is a legally binding document and constitutes an integral part of the agreements / terms and conditions of use between the Company and its merchants and users/customers.
          </p>
        </div>
      </div>

      {/* Information Collection Section */}
      <div className="row">
        <div className="col-12">
          <h2>What kind of Information do we collect?</h2>
          <p>
            We may collect from you two kinds of information:
          </p>
          <ul>
            <li>Personal Information;</li>
            <li>Non-personal Information</li>
          </ul>
        </div>
      </div>

      {/* Personal Information Section */}
      <div className="row">
        <div className="col-12">
          <h3>Personal Information</h3>
          <p>
            Personal Information refers to information collected from you that can be used to uniquely identify or contact you and includes your sensitive personal information.
          </p>
          <p>
            This will include but not be limited to, your:
          </p>
          <ul>
            <li>Name;</li>
            <li>Email address;</li>
            <li>Address (including country and ZIP/postal code);</li>
            <li>Gender;</li>
            <li>Age;</li>
            <li>Phone Number;</li>
            <li>Password chosen by you to access the platform;</li>
            <li>Geographical location;</li>
            <li>KYC documents</li>
            <li>Your profile picture (if any) that will be publicly displayed as part of your account profile. You may optionally provide us with this information through third-party sign-in services such as Facebook and Google. In such cases, We fetch and store whatever information is made available to us by you through these sign-in services.</li>
            <li>Financial account information like bank account details, GST certificate, PAN Card, etc. and transactional information in relation to transactions where the Company is involved;</li>
            <li>Any of the aforesaid information pertaining to your customer/buyer which is shared by you with the Company in the course of using the Services; and</li>
            <li>All other personally identifiable information/details as you may share from time to time (including personally identifiable information/details of your customer/buyer).</li>
          </ul>
        </div>
      </div>

      {/* Non-Personal Information Section */}
      <div className="row">
        <div className="col-12">
          <h3>Non-Personal Information</h3>
          <p>
            Non-Personal Information refers to information that cannot be used to identify you.
          </p>
          <p>
            Your preferences: Your preferences and settings such as time zone and language.
          </p>
          <p>
            Your content: Information you provide through our Services, including your reviews, photographs, comments, lists, followers, favourite categories, special requests and other information you provide on our Services, and other information in your account profile.
          </p>
        </div>
      </div>

      {/* Grievance Officer Section */}
      <div className="row">
        <div className="col-12">
          <h2>Grievance Officer</h2>
          <p>
            Any complaints, abuse or concerns with regards to content or comment or breach of the Privacy Policy may be informed to the designated Grievance Officer as mentioned below in writing or through email:
          </p>
          <p>
            <strong>Name:</strong> Murthy SN<br />
            <strong>Address:</strong> Helios Business Park, Wing E, 3rd Floor, Kadubeesanahalli, Kariyammana Agrahara Village, Varthur Hobli, Bengaluru East Taluk, Bengaluru Bengaluru, India, 560103<br />
            <strong>Email id:</strong> <a href="mailto:legalsupport@meesho.com">legalsupport@meesho.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacypolicy;